import React, { useEffect, useState } from "react";
import styled, { css, RuleSet } from "styled-components";
import { CompassParagraph, popAnimation } from "../common/styledComponents";
import {
  ElementContainer,
  FlexibleContainer,
} from "../containers/styledComponents";
import { formatNumber, formatPct } from "../../utils/formattingUtils";
import { greyText } from "../../styles";

const KPIValue = styled(CompassParagraph)<{
  animate?: boolean;
}>`
  display: inline-block;
  ${(props): false | RuleSet<object> | undefined =>
    props.animate &&
    css`
      animation: ${popAnimation} 0.4s ease-out;
    `}
`;

const formatValue = (value: number | string, isPercentage: boolean): string => {
  if (typeof value === "number") {
    return isPercentage ? formatPct(value) : formatNumber(value);
  }
  return String(value);
};

export const KPI = ({
  value,
  isPercentage = false,
  title = "",
}: KPIProps): JSX.Element => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (value) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 600); // Reset animation state after 0.6 seconds
      return () => clearTimeout(timer);
    }
  }, [value]);

  const formattedValue = formatValue(value, isPercentage);
  return (
    <FlexibleContainer
      fd="column"
      ai="flex-start"
      p="5px 25px"
      w="150px"
      ofx="auto"
    >
      <ElementContainer>
        <KPIValue fontSize={18} mr={1} animate={animate}>
          {formattedValue}
        </KPIValue>
      </ElementContainer>
      <CompassParagraph
        mt={1}
        color={greyText}
        fontSize={12}
        mr={1}
        ws="nowrap"
      >
        {title}
      </CompassParagraph>
    </FlexibleContainer>
  );
};

export type KPIProps = {
  value: number | string;
  isPercentage?: boolean;
  title?: string;
};
